import React, { useState, useEffect } from 'react';
import iconi from '../images/Vector 7.png';
import axiosInstance from '../components/api/AxiosInstance'; 
import { useNavigate } from 'react-router-dom';
import Loading from './Loading';

export default function Header() {
  const [departments, setDepartments] = useState([]);
  const [workerCounts, setWorkerCounts] = useState({});


// Loading
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);


  const navigate = useNavigate();

  useEffect(() => {
    axiosInstance.get("/company", { headers: { "ngrok-skip-browser-warning": "true" } })
      .then(response => {
        setDepartments(response.data.companies);
        response.data.companies.forEach(company => {
          fetchWorkerCount(company.id);
        });

        setIsLoading(false);

      })
      .catch(error => {
        console.error('Error fetching company data from API:', error);
        setIsLoading(false);

      });
  }, []);


  const fetchWorkerCount = (id) => {
    axiosInstance.get(`/users_by_company_id?company_id=${id}`, {
      headers: { "ngrok-skip-browser-warning": "true" }
    })
      .then(response => {
        setWorkerCounts(prev => ({ ...prev, [id]: response.data ? response.data.length : 0 }));
        setIsLoading(false);

      })
      .catch(error => {
        console.error(`Error fetching worker count for company ${id}:`, error);
        setWorkerCounts(prev => ({ ...prev, [id]: 0 }));
        setIsLoading(false);

      });
  };

  const goToDepartmentDetail = (id) => {
    navigate(`/home/${id}`);
  };


  if (loading || isLoading) {
    return <Loading />;
  }


  return (
    <div>
      <div className='header'>
        {departments?.map((e) => (
          <div className='header-item' key={e.id}>
            <div className='header-item-top'>
              <div className='header-item-top-left'>
                <h1>{e.name}</h1>
                <p>{e.phone_number}</p>
              </div>
              <div className='header-item-top-right'>
                <div>
                  <h2>{workerCounts[e.id] ?? 0}</h2>
                </div>
              </div>
            </div>
            <div className='header-item-bottom' onClick={() => goToDepartmentDetail(e.id)}>
              <h3>{e.region}</h3>
              <div><img src={iconi} alt='img'/></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
